export const THEMES = {
  TB_RED_ORANGE: 'tb-red-orange',
  TESTING_CENTRE: 'testing-centre',
  MTR_TAXI: 'mtr-taxi',
  COUNTER: 'counter',
  LEAVE_HOME_SAFE: 'leave-home-safe',
}